export enum ELegalCheckActions {
  SET_LEGAL_ID = 'legalCheck/setLegalId',
  SET_PRICE = 'legalCheck/setPrice',
  SET_AGREEMENT_PERSONAL = 'legalCheck/agreementPersonal',
  SET_AGREEMENT_OFFER = 'legalCheck/agreementOffer',
  SET_CURRENT_STEP = 'legalCheck/setCurrentStep',
  SET_IS_REGISTERED = 'legalCheck/setIsRegistered',
}
